import styles from './failed-login.module.scss';
import { Col, Row } from 'reactstrap';
import PageTitle from '../../page-title/page-title';
import { Box, Container } from '@frontend-workspace/react-shared-lib';
import LoginErrorLog from '../../login-error-log/login-error-log';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface FailedLoginProps { }

export function FailedLogin(props: FailedLoginProps) {
  const { t } = useTranslation();

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.loginFailed")} />
            <LoginErrorLog />
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default FailedLogin;